module.exports = __webpack_public_path__ + "static/media/chatnewicon.59541e16.svg";